import { Grid } from "@mui/material";
import useStyles from "../styles";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import { CountriesAndState, NigerianLGAs } from "../../../utils/DropDown";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react";
import Select from "react-select";
import { useUpload } from "../../../hooks/useUpload";
import Modal from "../../../components/Modal";

const PROFILE_ENDPOINT = "api/v1/profile";
// const UPLOAD_ENDPOINT = "/api/v1/upload";

const PersonalInformation = ({ data }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedfile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadForm, setUploadForm] = useState({});
  const [signatureFile, setSignatureFile] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [deleteStamp, setDeleteStamp] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [personalDetails, setPersonalDetails] = useState({
    first_name: data?.first_name,
    last_name: data?.last_name,
    // email: data?.email,
    gender: data?.gender,
    phone_number: data?.phone_number,
    address: data?.address,
    country: data?.country?.charAt(0)?.toUpperCase() + data?.country?.slice(1)?.toLowerCase()
  });

  const handleDeleteStamp = () => {
    setDeleteStamp(!deleteStamp);
  };

  /**
 * Removes the selected file.
 */
  const handleRemoveFile = () => setSignatureFile("");
  /**
 * Handles file input change and updates file state.
 * @param {Event} e - The file input change event.
 */
  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSignatureFile(e.target.files[0]);
    setUploadForm({ ...uploadForm, file: e.target.files[0].name.replaceAll(" ", "-") });
  };

  // const fullName = `${data?.first_name} ${data?.last_name}`;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPersonalDetails({ ...personalDetails, [name]: value });
    // If country changes, set its states
    if (name === "country") {
      const selectedCountry = CountriesAndState.find(
        (c) => c.name === value
      );

      if (selectedCountry && selectedCountry.states.length > 0) {
        // Map states into react-select options
        const options = selectedCountry.states.map((s) => ({
          value: s,
          label: s
        }));
        setStateOptions(options);
      } else {
        setStateOptions([]);
      }
    }
  };

  const handleStateChange = (selectedOption) => {
    setPersonalDetails((prev) => ({
      ...prev,
      state: selectedOption?.value
    }));
    setSelectedState(selectedOption);
  };

  // const handlePersonalUpdate = async () => {
  //   if (selectedfile) {
  //     const formData = new FormData();
  //     formData.append("file", selectedfile);
  //     try {
  //       setIsLoading(true);
  //       const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
  //       if (response?.status === 200) {
  //         const upload_id = response?.data?.data?.[0]?.upload_id;
  //         const file_url = response?.data?.data?.[0]?.file_url;

  //         const updatedEventForm = {
  //           ...personalDetails,
  //           display_pic: {
  //             upload_id,
  //             file_url
  //           }
  //         };
  //         const res = await httprequest.patch(PROFILE_ENDPOINT, updatedEventForm);
  //         setIsLoading(false);
  //         setSelectedFile(null);
  //         toast.success(res?.data?.message);
  //         window.location.reload();
  //       }
  //     } catch (error) {
  //       setIsLoading(false);
  //       toast.error(error?.response?.data?.message);
  //     }
  //   } else {
  //     setIsLoading(true);
  //     httprequest.patch(PROFILE_ENDPOINT, personalDetails)
  //       .then((res) => {
  //         setIsLoading(false);
  //         toast.success(res?.data?.message);
  //         window.location.reload();
  //       }).catch((err) => {
  //         setIsLoading(false);
  //         toast.error(err?.response?.data?.message);
  //       });
  //   }
  // };

  const handleDeleteSignature = () => {
    setIsDeleting(true);

    httprequest.patch(PROFILE_ENDPOINT, { signature: {} })
      .then((res) => {
        setIsDeleting(false);
        toast.success(res?.data?.message);
        handleDeleteStamp();

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        setIsDeleting(false);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const handlePersonalUpdate = async () => {
    setIsLoading(true);

    try {
      const allProfile = { ...personalDetails };

      // --- If no files selected, just update branding directly ---
      if (!selectedfile && !signatureFile) {
        const res = await httprequest.patch(PROFILE_ENDPOINT, allProfile);
        setIsLoading(false);
        toast.success(res?.data?.message);
        setTimeout(() => window.location.reload(), 2000);

        return;
      }

      const uploadPromises = [];

      // --- Prepare brand_logo upload ---
      if (selectedfile) {
        uploadPromises.push(useUpload(selectedfile));
      } else {
        uploadPromises.push(null);
      }

      // --- Prepare school_stamp upload ---
      if (signatureFile) {
        uploadPromises.push(useUpload(signatureFile));
      } else {
        uploadPromises.push(null);
      }

      // --- Run uploads in parallel ---
      const [profileRes, sigRes] = await Promise.all(uploadPromises);

      // --- Handle brand_logo response ---
      if (profileRes) {
        if (profileRes.status === 200 && profileRes.data.data) {
          allProfile.display_pic = {
            file_url: profileRes.data.data?.[0]?.file_url,
            upload_id: profileRes.data.data?.[0]?.upload_id
          };
        } else {
          toast.error("Unable to upload profile photo");
          setIsLoading(false);

          return;
        }
      }

      // --- Handle school_stamp response ---
      if (sigRes) {
        if (sigRes.status === 200 && sigRes.data.data) {
          allProfile.signature = {
            file_url: sigRes.data.data?.[0]?.file_url,
            upload_id: sigRes.data.data?.[0]?.upload_id
          };
        } else {
          toast.error("Unable to upload signature");
          setIsLoading(false);

          return;
        }
      }

      // --- Update branding with new values ---
      const res = await httprequest.patch(PROFILE_ENDPOINT, allProfile);

      setIsLoading(false);
      toast.success(res?.data?.message);

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  const handleProfileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setSelectedFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  useEffect(() => {
    setPersonalDetails({
      ...personalDetails,
      // first_name: data?.first_name,
      // last_name: data?.last_name,
      // role: data?.role,
      // email: data?.email,
      gender: data?.gender || "",
      phone_number: data?.phone_number || "",
      address: data?.address || "",
      country: data?.country || ""
    });
  }, [data]);

  const lgaOptions =
        personalDetails?.state && NigerianLGAs[data?.state]
          ? NigerianLGAs[personalDetails?.state].map((lga) => ({
            value: lga,
            label: lga
          }))
          : [];

  // populate states whenever country changes
  useEffect(() => {
    if (personalDetails?.country) {
      const countryObj = CountriesAndState.find(
        (c) => c.name === personalDetails?.country
      );

      if (countryObj && countryObj.states.length > 0) {
        const options = countryObj.states.map((s) => ({
          value: s,
          label: s
        }));
        setStateOptions(options);

        if (data?.state) {
          const match = options.find((opt) => opt.value === data.state) || null;
          setSelectedState(match);
        } else {
          setSelectedState(null);
        }
      } else {
        setStateOptions([]);
        setSelectedState(null);
      }
    } else {
      setStateOptions([]);
      setSelectedState(null);
    }
  }, [data?.country, data?.state]);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Personal Information</h4>
            <h6>Update your personal details here</h6>
            {/* <div className={classes.profilecontainer}>
              <div>
                <div className={classes.imageviewer}>
                  {preview && (
                    <img
                      src={preview}
                      alt="profile"
                      className={classes.previewImage}
                    />
                  )}
                </div>
                <div className={classes.selectcontainer}>
                  <input type="selectedfile" name="profile_picture" className={classes.profilepicker} onChange={handleProfileChange} />
                  <CameraAltIcon className={classes.camera} />
                </div>
              </div>
            </div> */}
            <div className={classes.profilecontainer}>
              <div className={classes.imageviewer}>
                {(preview || data?.display_pic?.file_url) && (
                  <img
                    src={preview || data?.display_pic?.file_url}
                    alt="profile"
                    className={classes.previewImage}
                  />
                )}
                <div className={classes.pickimage}>
                  <input type="file" name="profile_picture" onChange={handleProfileChange} className={classes.profilepicker} />
                  <CameraAltIcon className={classes.camera} />
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">
            <Grid container spacing={2} className={classes.profileform}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="First Name" inputName="first_name" defaultValue={data?.first_name} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Last Name" inputName="last_name" defaultValue={data?.last_name} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Other Name" inputName="other_names" defaultValue={data?.other_names} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Role" disabled defaultValue={data?.role?.name} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Email Address" defaultValue={data?.email} value={personalDetails?.email} disabled />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup label="Gender" value={personalDetails?.gender} children={
                  <select onChange={handleChange} name="gender" defaultValue={data?.gender}>
                    <option>---Select Gender---</option>
                    <option>male</option>
                    <option>female</option>
                  </select>
                }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Staff Category" inputName="staff_category" value={data?.staff_category} onChange={handleChange} disabled />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup required label="Country" children={
                  <select name="country" onChange={handleChange} defaultValue={personalDetails?.country}>
                    <option value="">---Select  ---</option>
                    {CountriesAndState?.map((country, index) => {
                      return (
                        <option key={index} value={country?.name}>{country?.name}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <div className="multiple-select">
                  <p className="input-picker-title">State of Origin</p>
                  <Select
                    onChange={handleStateChange}
                    options={stateOptions}
                    placeholder="Select State"
                    className="react-select-container"
                    name="state_of_origin"
                    value={selectedState}
                  />
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                {data?.country === "Nigeria" ? (
                  <div className="multiple-select">
                    <p className="input-picker-title">
            Local Government
                    </p>
                    <Select
                      onChange={handleChange}
                      options={lgaOptions}
                      placeholder="Select LGA"
                      className="react-select-container"
                      name="local_government"
                    />
                  </div>
                ) : (
                  <InputGroup
                    label="Local Government"
                    margin="normal"
                    inputType="text"
                    inputName="local_government"
                    defaultValue={data?.local_government}
                    onChange={handleChange}
                  />
                )}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Region" inputName="region" value={data?.region} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Phone Number" inputName="phone_number" value={personalDetails?.phone_number} onChange={handleChange} />
              </Grid>
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Country" inputName="country" value={personalDetails?.country} onChange={handleChange} />
              </Grid> */}
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Home Address" inputName="address" value={personalDetails?.address} onChange={handleChange} />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Reporting To" value={`${data?.reports_to?.last_name} ${data?.reports_to?.first_name}`} disabled />
              </Grid>
              {data?.signature?.file_url && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={classes.signatureWrap}>
                    <div className={classes.header}>
                      <div className={classes.signatureLabel}>
                      Signature
                      </div>
                      <div>
                        <Icon onClick={handleDeleteStamp} icon="material-symbols:delete-outline" width="24" height="24" style={{ color: "#b20c0cff" }} />
                      </div>
                    </div>
                    <div className={classes.signatureCard}>
                      {data?.signature?.file_url ? (
                        <img src={data?.signature?.file_url} alt="Stamp" className={classes.signatureImg} />
                      ) : (
                        <div className={classes.signatureEmpty}>No Signature uploaded</div>
                      )}
                    </div>
                  </div>
                </Grid>
              )}
              <Grid item lg={signatureFile ? 10 : 12} md={12} sm={12} xs={12}>
                <label className={`${classes.label}`}><p>Upload/Update Signature<span className="input-required">*</span></p> </label>
                <div className={classes.pickercontainer}>
                  <input type="file" className={classes.picker} onChange={handleFileChange} name="file" accept="image/jpeg,image/jpg,image/png" />

                  <div className={classes.uploadflex}>
                    <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                    {signatureFile?.name ? (
                      <div>
                        <h2 className={classes.uploadtitle}>{signatureFile?.name}</h2>
                      </div>
                    ) :
                      <div>
                        <p className={classes.uploadtitle}>Tap to Upload</p>
                        <p className={classes.uploadsubtitle}>JPG/PNG | 10MB max.
                        </p>
                      </div>}
                  </div>
                  <div className={classes.rightpicker}>
                    {signatureFile?.name ? (
                      <div className={classes.uploadbutton} onClick={handleRemoveFile}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                    ) : null}
                  </div>
                </div>
              </Grid>
              <Grid item lg={2} md={2} sm={12} xs={12}>
                <div className={classes.previewGrid}>
                  {signatureFile && (
                    <div className={classes.previewItem}>
                      <img
                        src={URL.createObjectURL(signatureFile)}
                        alt="preview"
                        className={classes.previewAnImage}
                      />
                      <div
                        className={classes.removeBtn}
                        onClick={() => handleRemoveFile()}
                      >
                        <Icon icon="zondicons:minus-solid" /> Remove
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" isLoading={isLoading} onClick={handlePersonalUpdate} />
            </div>
          </div>
        </Grid>
        {/* <ToastContainer /> */}
      </Grid>
      {/* Delete Modal */}
      <Modal
        title="Delete Signature"
        subtitle="Are you sure you want to delete this Signature? This action cannot be undone."
        modalContent={
          <>
            <div>
            </div>
          </>
        }
        modalFooter={
          <>
            <Button
              variant="danger"
              buttonName="Delete Signature"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeleteSignature}
              isLoading={isDeleting}
            />
          </>
        }
        isopen={deleteStamp}
        closeModal={handleDeleteStamp}
      />
    </>
  );
};

export default PersonalInformation;
